import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import LoadingSkeleton from '../../../../FlexibleCard/components/common/loading-skeleton';
import { CARD_WIDTH_REM } from '../../../styled';
import { getTitleStyles, loadingViewContainer, skeletonContainer, titleBlockStyles } from './styled';
import ActionGroup from '../../../../FlexibleCard/components/blocks/action-group';
import { CustomBlock } from '../../../../FlexibleCard/components/blocks';
import Icon from '../../../../FlexibleCard/components/elements/icon';
var HoverCardLoadingView = function HoverCardLoadingView(_ref) {
  var titleBlockProps = _ref.titleBlockProps;
  var testId = 'hover-card-loading-view';
  var lineHeightRem = 1.25;
  var skeletonWidth = CARD_WIDTH_REM - 2;
  var size = titleBlockProps.size,
    actions = titleBlockProps.actions;
  var actionGroup = (actions === null || actions === void 0 ? void 0 : actions.length) && (actions === null || actions === void 0 ? void 0 : actions.length) > 0 && jsx(ActionGroup, {
    items: actions,
    visibleButtonsNum: 2
  });
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("div", {
      css: loadingViewContainer,
      "data-testid": testId
    }, jsx("div", {
      css: skeletonContainer
    }, jsx(CustomBlock, _extends({}, titleBlockProps, {
      overrideCss: titleBlockStyles,
      testId: "".concat(testId, "-title-block")
    }), jsx(Icon, {
      render: function render() {
        return jsx(LoadingSkeleton, null);
      },
      size: size
    }), jsx("span", {
      css: getTitleStyles(lineHeightRem),
      "data-testid": "".concat(testId, "-title")
    }, jsx(LoadingSkeleton, {
      height: lineHeightRem
    })), actionGroup), jsx(LoadingSkeleton, {
      width: skeletonWidth,
      height: lineHeightRem
    }), jsx(LoadingSkeleton, {
      width: skeletonWidth,
      height: lineHeightRem * 3
    }), jsx(LoadingSkeleton, {
      width: skeletonWidth,
      height: lineHeightRem
    })))
  );
};
export default HoverCardLoadingView;